import Env from '../BsGetEnv'
let domainName
if(Env.isEnVlocal){
    domainName = ''
}else if (Env.isEnvOnline) {
    domainName = 'https://capis.didapinche.com'
} else if (Env.isEnvECS) {
    domainName = 'https://capis-ecs.didapinche.com'
} else {
    domainName = 'https://capis-test.didapinche.com'
}

// hermes平台特殊处理展示xxx数据
// 如果cms是线上，并且是预览就走线上接口

if (window.location.host === 'hermes.didachuxing.com' && (location.search.indexOf('env=simu')>-1 || 
    window.location.href.indexOf('server/view/project/preview') === -1)) {
    domainName = 'https://capis-ecs.didapinche.com'
}
export default domainName;